<template>
  <form @submit="sendForm" class="form-init">
    <h1 class="title">
      <span class="hola">¡HOLA! </span>
      <span class="queres">¿QUERÉS CONOCER EL MEJOR PLAN PARA VOS?</span
      ><br />EMPECEMOS POR ACÁ:
    </h1>
    <section class="container-fluid">
      <div class="columns">
        <div class="column">
          <InputUl
            @input="personNameChange"
            :width="'250px'"
            :inpType="'text'"
            :inpName="'pName'"
            :inpTitleStart="'Mi nombre es'"
            :inpTitleEnd="''"
            :inpRequired="true"
            :inpTab="'1'"
          />
        </div>
        <div class="column">
          <InputUl
            @input="personAgeChange"
            :width="'70px'"
            :inpType="'number'"
            :inpName="'pAge'"
            :inpMin="18"
            :inpTitleStart="'Tengo'"
            :inpTitleEnd="'años'"
            :inpRequired="true"
            :inpTab="'2'"
          />
        </div>
      </div>
    </section>

     


    <section class="container-fluid">
      <div class="columns">
        <div class="column">
          <label class="mr-3 text">Provincia</label>
         
          <select class="select" v-model="selectedProvincia"    @change="personProvinceChange">
            <option value="">Seleccionar provincia</option>
            <option
              v-for="provincia in provincias"
              :key="provincia.id"
              :value="provincia.id"
              
            >
              {{ provincia.name }}
            </option>
          </select>
         
        </div>

        <div class="column" >
          <label class="mr-3 text">Localidad</label>
          <select  class="select" v-model="selectedLocalidad" v-if="showLocalidades" @change="personLocalidadChange">
            <option  selected disabled value="">Seleccionar Localidad</option>
            <option
              v-for="localidad in localidades"
              :key="localidad.id"
              :value="localidad.id"
            >
              {{ localidad.name }}
            </option>
          </select>
        </div>
      </div>
    </section>

    <section class="container-fluid">
      <div class="columns">
        <div class="column is-12">
          <InputUl
            @change="personIsNoDocenteChange"
            :inpType="'checkbox'"
            :inpName="'pIsNoDocente'"
            :inpTitleStart="''"
            :inpTitleEnd="'Soy NODOCENTE de las UUNN'"
          />
        </div>
      </div>
    </section>
    <button class="button" type="submit">Cotizar</button>
  </form>
</template>

<script>
import InputUl from "./InputUl";
import axios from "axios";

export default {
  name: "FormInit",
  components: { InputUl },
  data() {
    return {
      person: {
        name: "",
        age: "",
        city: "",
        city_id: "",
        province: "",
        noDocente: false,
        email: "",
      },
      // Vars for data
 
      provincias: [],
      localidades: [],
      selectedProvincia: "",
      selectedLocalidad: "",
      showLocalidades: false 
    };
  },
  mounted() {
   
   
    this.listar_provincias();
  },

  watch: {
    selectedProvincia: function (newValue) {
      if (newValue !== "") {
        axios
          .get(
            "https://api.osfatun.com.ar/api/v1/locationsByProvincia/" + newValue
          )
          .then((response) => {
            this.localidades = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.localidades = [];
      }
    },
  },

  methods: {
    listar_provincias() {
      axios
        .get("https://api.osfatun.com.ar/api/v1/provincias")
        .then((res) => {
          this.provincias = res.data;
         this.showLocalidades = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    sendForm(e) {
      console.log(this.person);
      e.preventDefault();
      this.$gtag.pageview({ page_title: "Cotizar", page_path: "/cotizar" });
      this.$store.commit("setInitForm", this.person);
      this.$router.push({ name: "Cotizar" });
    },

    personLocalidadChange() {
      this.person.city = this.localidades.find(l => l.id === this.selectedLocalidad).name;
      this.person.city_id = this.selectedLocalidad;
    },
      personProvinceChange() {
      this.person.province = this.provincias.find(p => p.id === this.selectedProvincia).name
    },
    personNameChange(value) {
      this.person.name = value;
    },
    personIsNoDocenteChange(value) {
      this.person.noDocente = value;
    },
    personAgeChange(value) {
      this.person.age = value;
    },


  },
};
</script>

<style scoped>
.form-init {
  position: relative;
  top: -15vh;
  background: white;
  max-width: 83%;
  padding: 40px 30px;
  margin: 0 auto;
}
h1.title {
  font-weight: bold;
  font-size: 24px;
  color: #00758f;
  line-height: 1.9rem;
}
button {
  width: 195px;
  max-width: 195px !important;
  margin-left: auto !important;
  background: #00758f;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  display: block;
  text-transform: uppercase;
  border-radius: 0;
}
button:hover {
  width: 195px;
  font-weight: bold;
  color: #fff;
}
@media screen and (max-width: 480px) {
  .form-init {
    position: relative;
    top: -20px;
    padding: 40px 20px;
    margin: 0 auto;
  }
  .title {
    font-size: 20px !important;
    text-align: center;
    margin-bottom: 30px;
  }
  .title br {
    display: none;
  }
  .title .hola {
    display: block;
    font-size: 50px;
    margin-bottom: 20px;
  }
  .title .queres {
    display: block;
    margin-bottom: 20px;
  }
  .button {
    margin: 0 auto;
    max-width: 100% !important;
    width: 100% !important;
  }
}

.input-ul {
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;
  margin-bottom: 10px;
}
.input-ul li {
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}
.input-ul li:last-child {
  margin-right: 0;
}

input {
  background-color: transparent;
  /* width: initial!important; */
}

select,
input[type="text"],
input[type="email"],
input[type="number"] {
  border-radius: 0;
  border: 0;
  border-bottom: 3px solid #fbaf33;
  font-size: 17px !important;

}

.input-ul li:first-child,
.input-ul li:last-child {
  font-size: 24px;
  color: #00758f;
}

/* SQUARED ONE */
.squaredOne {
  width: 28px;
  height: 28px;
  background: #fcfff4;
  margin: 20px auto;
  position: relative;
}

.squaredOne label {
  cursor: pointer;
  position: absolute;
  width: 20px;
  height: 20px;
  left: 0;
  top: 0;
  border: 3px solid #fbaf33;
}

.squaredOne label:after {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: alpha(opacity=0);
  opacity: 0;
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  background: #fbaf33;
  top: 3px;
  left: 2px;
}

.squaredOne label:hover::after {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=30)";
  filter: alpha(opacity=30);
  opacity: 0.3;
}

.squaredOne input[type="checkbox"]:checked + label:after {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  filter: alpha(opacity=100);
  opacity: 1;
}

.text {
  font-weight: bold;
  font-size: 24px;
  color: #00758f;
  line-height: 1.9rem;
}
@media screen and (max-width: 480px) {
  .text {
    font-size: 20px;
    font-weight: normal;
  }
 
  input[type="text"] {
    width: 180px !important;
  }
  select {
    width: 90% !important;
    border-radius: 0;
    border: 0;
    background: transparent;
    border-bottom: 3px solid #fbaf33;

  }
}
</style>
